// Button Size
export enum EKwikUIAnimationPlayerType {
  LOTTIE = "lottie"
}
export const VKwikUIAnimationPlayerType = [
  EKwikUIAnimationPlayerType.LOTTIE
] as const;

export type TKwikUIAnimationPlayerType =
  (typeof VKwikUIAnimationPlayerType)[number];
